import axios from "axios"
// import _ from "underscore"
import qs from 'qs'
import * as util from "./util";


// axios.defaults.withCredentials = true

var instance = axios.create({
    baseURL: '/testback/',
    timeout: 5000,
    headers: { "Accept": "application/json;charset=UTF-8", "Content-Type": "application/json;charset=UTF-8" },
    responseType: 'json',
    withCredentials: true, // 携带跨域cookie

    //对url参数进行二次编辑
    //paramsSerializer: function (params) {
    //  return qs.stringify(params, { arrayFormat: 'brackets' })
    //},

    //对post参数进行二次编辑
    transformRequest: [function(data) {
        return JSON.stringify(data)
    }]

    //对返回值进行二次编辑
    // transformResponse: [function(data) {
    //     return data;
    // }],
    //httpAgent: new http.Agent({ keepAlive: true }),
    //httpsAgent: new https.Agent({ keepAlive: true }),
});


instance.interceptors.request.use(function(config) {
    config = {
        ...config,
        _v: Date.now()
    }
    return config
}, function(error) {
    return Promise.reject(error);
})

// Add a response interceptor
instance.interceptors.response.use(function(response) {
    // if (response && response.data && response.data.success) {
    if (response.status == 200 && response.data) {
        return response.data
    }
    let error = new Error('服务器异常，请稍后再试!')
    console.log(response)
    error.code = response.status
    error.data = response.statusText
    error.requrl = response.config.url
    throw error
}, function(error) {
    let err = new Error()
        // handle timeout
    if (error.config.method == 'get' && error.message.indexOf('timeout') == 0) {
        let retry = error.config['retry'] || 1
        if (retry >= 3) {
            err.code = 400
            err.message = '网络异常，请稍后再试!'
        } else {
            // 解决base url的问题
            error.config.url = error.config.url.replace(/\/api/g, '')
            error.config['retry'] = retry + 1
            return instance.request(error.config)
        }
    } else {
        // handle other error
        err.code = 500
        err.message = '服务器异常，请稍后再试!'
        if (error && error.response) {
            if (error.response.data) {
                let data = error.response.data
                err.code = data.code || 500
                err.message = data.message || '服务器异常，请稍后再试!'
            } else if (error.response.status !== 500) {
                err.code = 400
                err.message = '网络异常，请稍后再试!'
            }
        }
    }
    return Promise.reject(err)
})


// ----  接口定义开始-----
let defines = {
    //获取医护上门列表
    postBookedList: (params) => {
        let url = "/bookedService/getHomeVisitBookedList"
        return instance.post(url, params)
    },
    //医护上门列表跳详情页
    postBookedListDetail: (params) => {
        let url = "/booked/homecareticketdetail"
        return instance.post(url, params)
    },
    //去医院获取明星医生
    postClinicListDoctor: (params) => {
        let url = "/webclinic/getClinicDoctor"
        return instance.post(url, params)
    },
    //特色科室跳转或医生跳转
    clinicListKeshiOrDoctor: (params) => {
        let url = "/webclinic/getDeptDetailInfo"
        return instance.post(url, params)
    },
    // 医生详情页的擅长、简介 li
    getDoctorIntroduce: (params) => {
        return instance.get('/doctor/doctorIntroduce', params)
    },
    //HPV生成快照
    hpvServiceInfo: (params) => {
        return instance.post('/hpvGoodsPatient/add', params)
    },
    //关注医护
    collectHomecare: (params) => {
        return instance.post('/myHomeCare/addHomeCareRel', params)
    },
    //关注医护
    cancelCollectHomecare: (params) => {
        return instance.post('/myHomeCare/delHomeCareRel', params)
    },
}

let apis = {}
Object.keys(defines).forEach((name) => {
    apis[name] = function(params) {
        var req = defines[name](params)
        return req;
    };
});
export default apis


// WEBPACK FOOTER //
// ./src/lib/api.new.js